import {
  generateObjectZeroId,
  getPermission,
  simpleAlert,
  SubLine,
} from "components/CommonLib/CommonLib";
import Loading from "components/Loading/Loading/Loading";
import ModalPopupLocal from "components/ModalPopup/ModalPopupLocal";
import NormalBtn from "components/NewButton/NormalBtn";
import { useMemberLocationStats } from "hooks/apis/branch/useMemberLocation";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useMemberLocationStore } from "../modules/store/memberLocationState";
import CreatePopup from "./CreatePopup";
import MemberLocationStatsResultTable from "./MemberLocationStatsResultTable";
import SearchCondition from "./SearchCondition";

const MemberLocationStatsView = ({ isAdmin }) => {
  const storesDispatch = useDispatch();
  // 전역 상태 관리
  const {
    memberLocationSearchParams: searchParams,
    setSearchParams,
    resetSearchParams,
  } = useMemberLocationStore();

  // 페이지 상태 관리
  const [searchResult, setSearchResult] = useState([]);
  const [totalPage, setTotalPage] = useState(1);
  const [resetFlag, setResetFlag] = useState(false);

  const [branchList, setBranchList] = useState([]);

  // API 상태 관리
  const [isGetMemberLocationStats, setIsGetMemberLocationStats] = useState(false);

  const { data: memberLocationStats, isFetching } = useMemberLocationStats(
    searchParams,
    isGetMemberLocationStats,
    setIsGetMemberLocationStats,
  );

  useEffect(() => {
    getBranchList();
  }, []);

  // 지점 권한 받아오기
  const getBranchList = async () => {
    const branchResult = await getPermission(
      storesDispatch,
      "ACCESS_MENU/MANAGE",
      true,
      true,
      true,
    );
    setBranchList(branchResult);
    if (
      branchResult.branch_list.length > 0 &&
      searchParams.branch_info.branch_id === generateObjectZeroId()
    ) {
      setSearchParams("branch_info", branchResult.branch_list[0]);
    }
  };

  // modal 변수
  const viewModelRef = useRef();
  const [modalInfo, setModalInfo] = useState({
    show: false,
    title: "",
    Content: "",
    callback: null,
    Buttons: undefined,
  });

  // 회원 위치 통계 리스트 가져오기
  const onClickSearch = async (page) => {
    if (searchParams.branch_info.branch_id === "") {
      simpleAlert(storesDispatch, "알림", "지점을 선택해주세요.");
      return;
    }

    setIsGetMemberLocationStats(true);
    setSearchParams("page_number", page);
  };

  ////////

  const onModalDone = (data) => {
    viewModelRef.current.setClose();

    console.log("done:", data);
  };
  ////////////

  const openCreatePopup = () => {
    const param = {
      getBranchList,
    };

    setModalInfo({
      show: true,
      title: "위치 통계 데이터 생성",
      Content: <CreatePopup modalParam={param} onModalDone={onModalDone} />,
      callback: null,
      Buttons: undefined,
    });
  };
  // 데이터 받아오기 @@@@@@
  useEffect(() => {
    if (memberLocationStats) {
      setSearchResult(memberLocationStats.data.data);
      setTotalPage(memberLocationStats.data.total_page);
    }
  }, [memberLocationStats]);

  // 페이지 진입 시 결과 받아오기
  useEffect(() => {
    onClickSearch(1);
  }, []);

  return (
    <div>
      {isFetching ? <Loading /> : <></>}

      <ModalPopupLocal ref={viewModelRef} params={modalInfo} />

      <div>
        <SearchCondition
          searchParams={searchParams}
          setSearchParams={setSearchParams}
          branchList={branchList}
          onClickSearch={onClickSearch}
          resetFlag={resetFlag}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "0.75rem",
            gap: "0.3rem",
          }}
        >
          <NormalBtn
            name="초기화"
            theme="white"
            width="6.25rem"
            onClick={() => {
              resetSearchParams();
              setResetFlag(!resetFlag);
            }}
          />
          <NormalBtn
            name="검색"
            width="6.25rem"
            onClick={() => {
              onClickSearch(1);
            }}
          />
        </div>
      </div>

      <SubLine />
      <div style={{ display: "flex", justifyContent: "end", marginBottom: "0rem" }}>
        <NormalBtn
          name="생성"
          width="6.25rem"
          onClick={() => {
            openCreatePopup();
          }}
        />
      </div>

      <div style={{ marginTop: "0.5rem" }}>
        <MemberLocationStatsResultTable
          searchResult={searchResult}
          curPage={searchParams.page_number}
          totalPage={totalPage}
          onClickSearch={onClickSearch}
          isAdmin={isAdmin}
        />
      </div>
    </div>
  );
};
export default MemberLocationStatsView;
